<template>
  <!-- 便民查询表 -->
  <div class="buttonlist">
    <el-form
      :inline="true"
      :model="filteForm"
      class="demo-form-inline toolbar"
      style="padding-bottom: 0px"
      @submit.native.prevent>
      <el-form-item label="项目名称">
        <el-input v-model.trim="filteForm.name" auto-complete="off" maxlength="25" class="width80"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          icon="el-icon-search"
          plain
          @click="onSubmit">查询</el-button> 
        <el-button type="warning" icon="el-icon-plus" @click="addPj" plain>新增</el-button>
        <el-button type="success" icon="el-icon-notebook-2" @click="showRecord" plain>查询记录</el-button>
      </el-form-item>
    </el-form>
    <div v-loading="loading" element-loading-text="拼命加载中......">
      <el-table
        :data="tableData"
        style="width: 100%"
        :row-style="tableRowStyle"
        :header-cell-style="tableHeaderColor">
        <el-table-column prop="name" label="标题" align=center></el-table-column>
        <el-table-column prop="content" :show-overflow-tooltip="true" label="内容" align=center></el-table-column>
        <el-table-column prop="url" label="链接" :show-overflow-tooltip="true" align=center></el-table-column>
        <el-table-column prop="creator" label="创建人" align=center></el-table-column>
        <el-table-column prop="createdTime" :width="150" label="创建时间" align=center></el-table-column>
        <el-table-column
            prop="option"
            label="操作"
            align="center"
            width="150">
            <template slot-scope="scope">
              <el-button
                type="primary"
                size="mini"
                plain
                @click="editPj(scope.row)"
                >编辑</el-button>
              <el-button
               type="warning"
               size="mini"
               plain
               @click="showDetail(scope.row)"
               >查询</el-button>
            </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        @current-change="handleCurrentChange"
        :current-page="pageNum"
        layout="total, prev, pager, next"
        :total="totalDataNumber"
        :page-size="pageSize"
        align="center"
        class="fenye"
      ></el-pagination>
    </div>

    <!-- 新增/编辑查询项目弹窗 -->
    <el-dialog :title="addForm.id==null ? '新增查询项目' : '修改查询项目'" width="60%" 
    :visible.sync="pjShow">
      <el-form :model="addForm" label-width="120px" label-position="right">
        <el-form-item label="标题" prop="name">
          <el-input v-model.trim="addForm.name" auto-complete="off" placeholder="" style="width:80%;"></el-input>
        </el-form-item>
        <el-form-item label="链接" prop="url">
          <el-input v-model.trim="addForm.url" auto-complete="off" placeholder="" style="width:80%;"></el-input>
        </el-form-item>
        <el-form-item label="内容" prop="content">
          <el-input v-model.trim="addForm.content" auto-complete="off" 
          placeholder="问题描述.500字以内"
          type="textarea"
          :rows="5"
          show-word-limit
          maxlength="500"
          style="width:80%;"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" align="center">
        <el-button @click.native="pjShow = false">取消</el-button>
        <el-button type="primary" @click.native="submitAddForm">确定</el-button>
      </div>
    </el-dialog>

    <!-- 查询人信息弹窗 -->
    <el-dialog 
      title="填写查询人信息" 
      width="50%" 
      :visible.sync="queryDialogVisible"
      :close-on-click-modal="false">
      <el-form 
        :model="queryForm" 
        :rules="queryRules" 
        ref="queryFormRef" 
        label-width="100px" 
        label-position="right">
        <el-form-item label="姓名" prop="user">
          <el-select
            v-model="queryForm.user"
            filterable
            remote
            clearable
            placeholder="请输入姓名搜索"
            :remote-method="searchOldMan"
            :loading="oldManLoading"
            style="width:100%"
            @change="handleOldManSelect">
            <el-option
              v-for="item in oldManOptions"
              :key="item.oldmanId"
              :label="item.oldName"
              :value="item.oldName">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="联系电话" prop="phone">
          <el-input 
            v-model.trim="queryForm.phone" 
            auto-complete="off" 
            placeholder="选择老人后自动填充"
            maxlength="20"></el-input>
        </el-form-item>
        <el-form-item label="身份证号" prop="idCard">
          <el-input 
            v-model.trim="queryForm.idCard" 
            auto-complete="off" 
            placeholder="选择老人后自动填充"
            maxlength="18"></el-input>
        </el-form-item>
        <el-form-item label="地址" prop="address">
          <el-input 
            v-model.trim="queryForm.address" 
            auto-complete="off" 
            placeholder="选择老人后自动填充"
            maxlength="200"></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="content">
          <el-input 
            v-model.trim="queryForm.content" 
            type="textarea"
            :rows="3"
            auto-complete="off" 
            placeholder="请输入备注说明"
            maxlength="500"
            show-word-limit></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" align="center">
        <el-button @click.native="closeQueryDialog">取消</el-button>
        <el-button type="primary" @click.native="submitQuery">确认查询</el-button>
      </div>
    </el-dialog>

  </div>
</template>
<script>
import bus from "@/vuex/eventBus"; //引入eventBus,接收子界面传递的跳转指令,然后在父界面跳转,添加tab

export default {
  data() {
    // 身份证号验证
    const validateIdCard = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入身份证号'));
      } else {
        const reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
        if (!reg.test(value)) {
          callback(new Error('请输入正确的身份证号'));
        } else {
          callback();
        }
      }
    };
    
    // 手机号验证
    const validatePhone = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入联系电话'));
      } else {
        const reg = /^1[3-9]\d{9}$/;
        if (!reg.test(value)) {
          callback(new Error('请输入正确的手机号'));
        } else {
          callback();
        }
      }
    };
    
    return {
      pageNum: 1, //页码
      pageSize: 10, //每页显示的条数
      totalDataNumber: 0,
      loading: true,
      addForm: {},
      pjShow: false,
      dayStr: "",
      filteForm: {
        type: "",
        name: ""
      },
      tableData: [],
      typeList: [],
      
      // 查询人信息相关
      queryDialogVisible: false,
      currentQueryItem: null, // 当前要查询的项目
      queryForm: {
        user: '',
        phone: '',
        idCard: '',
        address: '',
        content: '',
        projectName: '' // 查询的项目名称
      },
      queryRules: {
        user: [
          { required: true, message: '请选择查询人', trigger: 'change' }
        ],
        phone: [
          { required: true, validator: validatePhone, trigger: 'blur' }
        ],
        idCard: [
          { required: true, validator: validateIdCard, trigger: 'blur' }
        ],
        address: [
          { required: true, message: '请输入联系地址', trigger: 'blur' },
          { min: 2, max: 200, message: '长度在 2 到 200 个字符', trigger: 'blur' }
        ],
      },
      // 老人下拉搜索
      oldManOptions: [],
      oldManLoading: false,
      oldManMap: {} // 缓存老人信息，key 为 oldName
    };
  },
  methods: {
    showRecord() {
      bus.$emit("homePage", {
          type: "jump",
          path: "/ConvenientSearchRecord",
          title: '便民查询记录'
      });
    },
    
    // 显示查询人信息弹窗
    showDetail(row) {
      this.currentQueryItem = row;
      this.queryForm = {
        user: '',
        phone: '',
        idCard: '',
        address: '',
        content: '',
        projectName: row.name
      };
      this.oldManOptions = [];
      this.oldManMap = {};
      this.queryDialogVisible = true;
      // 清除表单验证状态
      this.$nextTick(() => {
        if (this.$refs.queryFormRef) {
          this.$refs.queryFormRef.clearValidate();
          this.searchOldMan();
        }
      });
    },
    
    // 关闭查询弹窗
    closeQueryDialog() {
      this.queryDialogVisible = false;
      this.currentQueryItem = null;
      this.oldManOptions = [];
      this.oldManMap = {};
      if (this.$refs.queryFormRef) {
        this.$refs.queryFormRef.resetFields();
      }
    },
    
    // 远程搜索老人
    searchOldMan(query) {
      // if (!query) {
      //   this.oldManOptions = [];
      //   return;
      // }
      this.oldManLoading = true;
      this.$postJson('omc/Oldman/quickShowAllOldMan', {
        oldName: query,
        pageNo: '1',
        pageSize: '20'
      }).then(res => {
        const list = (res.result && res.result.list) || (res.list) || [];
        this.oldManOptions = list;
        // 缓存老人信息
        list.forEach(item => {
          this.oldManMap[item.oldName] = item;
        });
      }).finally(() => {
        this.oldManLoading = false;
      });
    },
    
    // 选择老人后回显信息
    handleOldManSelect(val) {
      const info = this.oldManMap[val];
      if (info) {
        this.queryForm.phone = info.oldPhone || '';
        this.queryForm.idCard = info.oldIdCard || '';
        this.queryForm.address = info.oldAddress || '';
      } else {
        this.queryForm.phone = '';
        this.queryForm.idCard = '';
        this.queryForm.address = '';
      }
    },
    
    // 提交查询
    submitQuery() {
      this.$refs.queryFormRef.validate((valid) => {
        if (valid) {
          let params = {
            name: this.currentQueryItem.name,
            user: this.queryForm.user,
            phone: this.queryForm.phone,
            idCard: this.queryForm.idCard,
            address: this.queryForm.address,
            content: this.queryForm.content
          };
          
          // 提交查询记录
          this.$postJson('omc/convenientSearch/addRecord', params).then(res => {
            if (res.code == 200) {
              this.$message.success('查询记录已保存');
              // 打开查询链接
              window.open(this.currentQueryItem.url);
              this.closeQueryDialog();
            } else {
              this.$message({
                message: "记录保存失败, " + res.message,
                type: "error",
              });
              // 即使记录保存失败，也允许打开链接
              window.open(this.currentQueryItem.url);
              this.closeQueryDialog();
            }
          }).catch(() => {
            // 接口调用失败，也允许打开链接
            window.open(this.currentQueryItem.url);
            this.closeQueryDialog();
          });
        } else {
          return false;
        }
      });
    },
    
    addPj() {
      this.pjShow = true;
      this.addForm = {
        name: "",
        url: "",
        content: ""
      };
    },
    editPj(item) {
      this.pjShow = true;
      this.addForm = Object.assign({}, item);
    },
    submitAddForm() {
      let url = 'omc/convenientSearch/addPj';
      if (this.addForm.id != null) {
        url = 'omc/convenientSearch/updatePj';
      }
      let params = Object.assign({}, this.addForm);
      this.$postJson(url, params).then(res => {
        if (res.code == 200) {
          this.pjShow = false;
          this.onSubmit();
        } else {
            this.$message({
              message: "操作失败, " + res.message,
              type: "error",
            });
        }
      });
    },
    //点击查询
    onSubmit() {
      this.pageNum = 1;
      this.getTableData();
    },
    tableRowStyle({ row, rowIndex }) {
      if (rowIndex % 2 == 0) {
        return "background-color: #ffffff";
      } else {
        return "background-color: #e4f5f8";
      }
    },
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "color:#2d2d2d;font-weight: 600; text-align: center;font-size: 16px;background-color: #d4f5fa;";
      }
    },
    //获取分页的紧急按钮数据  只获取pageSize条数据
    getTableData() {
      let params = {
        groupId: this.groupId,
        pageSize: this.pageSize,
        name: this.filteForm.name || undefined,
        pageNum: this.pageNum
      };
      this.loading = true;
      this.$postJson('omc/convenientSearch/showPjList', params).then(res => {
        if (res.code == 200) {
          this.totalDataNumber = Number(res.result.total);
          this.tableData = res.result.list;
        }
        this.loading = false;
      });
    },
    handleCurrentChange(val) {
      this.pageNum = val;
      this.getTableData();
    },
    
  },
  mounted() {
    // 模拟数据加载（实际项目中应该调用接口）
    this.loading = true;
    this.getTableData();
  },
  created() {
    this.groupId = sessionStorage.getItem("groupId") || 'default-group';
  },
};
</script>
<style lang="scss" scoped>
.buttonlist {
    padding: 10px 0 0 5px;
    background: #fff;
    border-radius: 4px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.toolbar {
  margin-bottom: 20px;
}

.width80 {
  width: 200px;
}

.fenye {
  margin: 0;
  padding: 30px 0;
  background: #fff;
}

.demo-form-inline {
  padding: 15px 20px;
  background: #fff;
  border-bottom: 1px solid #eee;
}
</style>
